import React, { useContext } from "react"
import LocaleContext from "../../../../../context/LocaleContext"
import translate, { keys } from "../../../../../translation/translator"
import HomeBlogPostsWrapperStyle from "./HomeBlogPostsWrapperStyle.module.styl"

const HomeBlogPostsWrapper = ({ children }) => {
  const locale = useContext(LocaleContext).locale

  return (
    <div className={HomeBlogPostsWrapperStyle.wrapper}>
      <h2 className={HomeBlogPostsWrapperStyle.title}>
        {translate(keys.INDEX_BLOG_WRPR_HLP_FR_U, locale)}
      </h2>
      {children}
    </div>
  )
}

export default HomeBlogPostsWrapper
